import policyModificationApi from '../../../api/policyModification.api'

export const getPolicyDetails = async insuranceId => {
  let res = await policyModificationApi.getPolicyDetails(insuranceId)
  return res
}
